"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const FieldSelfStepCreateArray = (props, setThisStep) => {
    var _a, _b, _c, _d, _e, _f;
    try {
        const isLoadData = ((_a = Object.keys(props === null || props === void 0 ? void 0 : props.loadData)) === null || _a === void 0 ? void 0 : _a.length) > 0;
        if (isLoadData) {
            if (props.grandParentIndex >= 0 &&
                props.parentKey &&
                ((_b = props.loadData[props.parentKey]) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
                props.grandParentKey === props.parentKey) {
                // console.log("IN CREATE 1", props);
                const create = new Array((_c = props.loadData[props.parentKey]) === null || _c === void 0 ? void 0 : _c.length).fill(props.fields);
                setThisStep(create);
            }
            else if (props.grandParentIndex >= 0 &&
                props.parentKey &&
                props.grandParentKey !== props.parentKey &&
                (props.parentIndex === undefined || props.parentIndex === null)) {
                // console.log("IN CREATE 2", props);
                const create = new Array((_d = props.loadData[props.grandParentKey][props.parentKey]) === null || _d === void 0 ? void 0 : _d.length).fill(props.fields);
                setThisStep(create);
            }
            else if (props.grandParentIndex >= 0 &&
                props.parentKey &&
                ((_e = props.loadData[props.grandParentKey][props.parentIndex][props.parentKey]) === null || _e === void 0 ? void 0 : _e.length) > 0 &&
                props.grandParentKey !== props.parentKey) {
                // console.log("IN CREATE 3", props);
                const create = new Array((_f = props.loadData[props.grandParentKey][props.parentIndex][props.parentKey]) === null || _f === void 0 ? void 0 : _f.length).fill(props.fields);
                setThisStep(create);
            }
            else {
                // console.log("IN CREATE 3", props);
                return;
            }
        }
        else {
            // console.log("IN CREATE 4", props);
            return;
        }
    }
    catch (error) {
        // console.log("ERROR TO ADD ARRAY :", error);
    }
    //OLD
    // try {
    //   if (props.loadData) {
    //     if (
    //       props.grandParentIndex &&
    //       props.parentKey &&
    //       props.loadData[props.parentKey]?.length > 0 &&
    //       props.grandParentKey === props.parentKey
    //     ) {
    //       console.log("IN CREATE 1", props);
    //       const create = new Array(props.loadData[props.parentKey]?.length).fill(
    //         props.fields
    //       );
    //       setThisStep(create);
    //     } else if (
    //       props.grandParentIndex &&
    //       props.parentKey &&
    //       props.loadData[props.grandParentKey][props.parentIndex][props.parentKey]
    //         ?.length > 0 &&
    //       props.grandParentKey !== props.parentKey
    //     ) {
    //       console.log("IN CREATE 3", props);
    //       const create = new Array(
    //         props.loadData[props.grandParentKey][props.parentIndex][
    //           props.parentKey
    //         ]?.length
    //       ).fill(props.fields);
    //       setThisStep(create);
    //     } else {
    //       console.log("IN CREATE 3", props);
    //       return;
    //     }
    //   } else {
    //     console.log("IN CREATE 4", props);
    //     return;
    //   }
    // } catch (error) {
    //   console.error("ERROR TO ADD ARRAY :", error);
    // }
};
exports.default = FieldSelfStepCreateArray;
